import { BsModalRef } from 'ngx-bootstrap/modal'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { AppState } from 'src/app/core/core.state'
import { Store } from '@ngrx/store'
import { Actions, ofType } from '@ngrx/effects'
import { NotificationService } from 'src/app/core/notification.service'
import { Observable, of, Subject } from 'rxjs'
import { take, timeout, catchError } from 'rxjs/operators'
import {
  EmployeeBooking,
  EmployeeBookingColourCodes
} from '../employee-booking'
import { employeeBookingActions } from '../employee-booking.actions'
import { Member } from 'src/app/features/member/member'
import { authSelectors } from 'src/app/core/auth/auth.selectors'
import moment from 'moment-mini'
import { persistentUserRoleSelectors } from 'src/app/features/role/user-role/persistent-user-role/persistent-user-role.selector'
import { environment } from 'src/environments/environment'
import { sanitizeIdentifier } from '@angular/compiler'

@Component({
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class EmployeeBookingCreateModalComponent implements OnInit {
  @Input() title: string = 'bookingModule.createBooking'
  @Input() employeeBooking: Partial<EmployeeBooking>
  @Input() bookingIsAlreadyChecked: boolean = false
  @Input() hasOnlyTrainerRole: boolean = false
  @Input() allTimeBlocksOfMember: any = []
  @Output() updateEmployeeBooking: EventEmitter<any> = new EventEmitter()

  public disableSaveButton$: Subject<boolean> = new Subject<boolean>()
  public member$: Observable<Member>
  public employeeBookingColourCodes = EmployeeBookingColourCodes

  public wasBookingCancelled: boolean

  constructor(
    private bsModalRef: BsModalRef,
    private store: Store<AppState>,
    private actions$: Actions,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.wasBookingCancelled = false
    this.member$ = this.store.select(authSelectors.selectMember)
  }

  public cancel() {
    this.bsModalRef.hide()
  }

  public onEmployeeBookingCancel(result: boolean) {
    if (!result) {
      this.disableSaveButton$.next(false)
      return
    }

    this.wasBookingCancelled = result
    this.disableSaveButton$.next(false)
    this.bsModalRef.hide()
  }

  public getDaysBetweenDates(startDate, endDate) {
    let now = moment(startDate).clone().startOf('day').clone(),
      dates = []

    if (
      moment(endDate).clone().startOf('day').valueOf() ==
      moment(endDate).valueOf()
    ) {
      endDate.subtract(1, 'minutes')
    }
    while (now.isSameOrBefore(endDate)) {
      dates.push(now.format('YYYY-MM-DD'))
      now.add(1, 'days')
    }
    return dates
  }

  public onSubmit(employeeBooking: Partial<EmployeeBooking>) {
    if (
      !moment(employeeBooking.endDate).isValid() ||
      !moment(employeeBooking.startDate).isValid() ||
      moment(employeeBooking.endDate).valueOf() <=
        moment(employeeBooking.startDate).valueOf() ||
      (moment(employeeBooking.endDate).format('YYYY-MM-DD') ==
        moment(employeeBooking.startDate).format('YYYY-MM-DD') &&
        moment(employeeBooking.endDate).format('HH:mm') ==
          moment(employeeBooking.startDate).format('HH:mm'))
    ) {
      this.notificationService.emit(
        'employeeModule.endTimeEarlierThanStartTime',
        'warning'
      )
      this.disableSaveButton$.next(false)
      return
    }
    if (this.allTimeBlocksOfMember && this.allTimeBlocksOfMember.length > 0) {
      let isBusy = false
      this.allTimeBlocksOfMember.map((days) => {
        if (
          days.isoWeekDayNumber >= moment(employeeBooking.startDate).day() &&
          days.isoWeekDayNumber <= moment(employeeBooking.endDate).day()
        ) {
          if (
            moment(
              moment(employeeBooking.startDate).format('HH:mm'),
              'HH:mm'
            ).isBetween(
              moment(days.startTime, 'HH:mm'),
              moment(days.endTime, 'HH:mm')
            ) ||
            moment(
              moment(employeeBooking.endDate).format('HH:mm'),
              'HH:mm'
            ).isBetween(
              moment(days.startTime, 'HH:mm'),
              moment(days.endTime, 'HH:mm')
            ) ||
            (moment(days.startTime, 'HH:mm').isBetween(
              moment(
                moment(employeeBooking.startDate).format('HH:mm'),
                'HH:mm'
              ),
              moment(moment(employeeBooking.endDate).format('HH:mm'), 'HH:mm')
            ) &&
              moment(days.endTime, 'HH:mm').isBetween(
                moment(
                  moment(employeeBooking.startDate).format('HH:mm'),
                  'HH:mm'
                ),
                moment(moment(employeeBooking.endDate).format('HH:mm'), 'HH:mm')
              ))
          )
            if (!days.isAvailable) {
              isBusy = true
            }
        }
      })
      if (isBusy) {
        this.notificationService.emit('employeeModule.isUnAvailable', 'warning')
        this.disableSaveButton$.next(false)
        return
      }
    }
    let daysOfBooking = null

    if (
      moment(employeeBooking.endDate).isAfter(
        moment(employeeBooking.startDate).endOf('day')
      )
    ) {
      daysOfBooking = this.getDaysBetweenDates(
        employeeBooking.startDate,
        employeeBooking.endDate
      )
    }

    if (!this.employeeBooking?.contractId && !employeeBooking?.contractId) {
      this.member$.pipe(take(1)).subscribe((member) => {
        // UPDATE BOOKING
        if (this.employeeBooking.id) {
          // multiday booking
          if (daysOfBooking) {
            this.updateMultidayBooking(employeeBooking, daysOfBooking, member)
          }
          // single day booking
          else {
            this.store.dispatch(
              employeeBookingActions.updateOneById({
                id: this.employeeBooking.id,
                params: {
                  ...employeeBooking,
                  id: this.employeeBooking.id,
                  endDate: moment(employeeBooking.endDate).subtract(
                    1,
                    'minute'
                  ),
                  // moment(employeeBooking.endDate).minutes() != 59
                  //   ? moment(employeeBooking.endDate).subtract(2, 'minute')
                  //   : moment(employeeBooking.endDate).subtract(1, 'minute'),
                  colour: this.employeeBookingColourCodes.BY_WEBSITE,
                  contractId: employeeBooking.contractId
                    ? parseInt(employeeBooking.contractId.toString())
                    : null,
                  personId: member?.id
                }
              })
            )
          }
        }
        // CREATE BOOKING
        else {
          // multiday booking
          if (daysOfBooking) {
            this.createMultidayBooking(employeeBooking, daysOfBooking, member)
          }
          // single day booking
          else {
            this.store
              .select(persistentUserRoleSelectors.selectSelectedUserRole)
              .pipe(take(1))
              .subscribe((pUr) => {
                const siteId =
                  pUr && pUr.siteId ? pUr.siteId : environment.defaultSiteId
                this.store.dispatch(
                  employeeBookingActions.createOne({
                    entity: {
                      siteId: siteId,
                      ...employeeBooking,
                      ...this.employeeBooking,
                      productId: employeeBooking.productId
                        ? parseInt(employeeBooking.productId.toString())
                        : null,
                      startDate: moment(employeeBooking.startDate),
                      endDate: moment(employeeBooking.endDate).subtract(
                        1,
                        'minute'
                      ),
                      // moment(employeeBooking.endDate).minutes() != 59
                      //   ? moment(employeeBooking.endDate).subtract(
                      //       2,
                      //       'minute'
                      //     )
                      //   : moment(employeeBooking.endDate).subtract(
                      //       1,
                      //       'minute'
                      //     ),
                      contractId: employeeBooking.contractId
                        ? parseInt(employeeBooking.contractId.toString())
                        : null,
                      type: parseInt(employeeBooking.type.toString()),
                      personId: member.id,
                      colour: this.employeeBookingColourCodes.BY_WEBSITE
                    }
                  })
                )
              })
          }
        }
      })
    } else {
      const contractId =
        this.employeeBooking?.contractId ?? employeeBooking.contractId

      this.member$.pipe(take(1)).subscribe((member) => {
        if (this.employeeBooking.id) {
          // multiday booking
          if (daysOfBooking) {
            this.updateMultidayBooking(employeeBooking, daysOfBooking, member)
          }
          // single day booking
          else {
            this.store.dispatch(
              employeeBookingActions.updateOneById({
                id: this.employeeBooking.id,
                params: {
                  ...employeeBooking,
                  id: this.employeeBooking.id,
                  endDate: moment(employeeBooking.endDate).subtract(
                    1,
                    'minute'
                  ),
                  // moment(employeeBooking.endDate).minutes() != 59
                  //   ? moment(employeeBooking.endDate).subtract(2, 'minute')
                  //   : moment(employeeBooking.endDate).subtract(1, 'minute'),
                  colour: this.employeeBookingColourCodes.BY_WEBSITE,
                  contractId: employeeBooking.contractId
                    ? parseInt(employeeBooking.contractId.toString())
                    : null,
                  personId: member?.id
                }
              })
            )
          }
        } else {
          // multiday booking
          if (daysOfBooking) {
            this.createMultidayBooking(employeeBooking, daysOfBooking, member)
          }
          // single day booking
          else {
            this.store
              .select(persistentUserRoleSelectors.selectSelectedUserRole)
              .pipe(take(1))
              .subscribe((pUr) => {
                const siteId =
                  pUr && pUr.siteId ? pUr.siteId : environment.defaultSiteId
                this.store.dispatch(
                  employeeBookingActions.createOne({
                    entity: {
                      siteId: siteId,
                      ...employeeBooking,
                      ...this.employeeBooking,
                      productId: employeeBooking.productId
                        ? parseInt(employeeBooking.productId.toString())
                        : null,
                      startDate: employeeBooking.startDate,
                      endDate: moment(employeeBooking.endDate).subtract(
                        1,
                        'minute'
                      ),
                      // moment(employeeBooking.endDate).minutes() != 59
                      //   ? moment(employeeBooking.endDate).subtract(
                      //       2,
                      //       'minute'
                      //     )
                      //   : moment(employeeBooking.endDate).subtract(
                      //       1,
                      //       'minute'
                      //     ),
                      contractId: employeeBooking.contractId
                        ? parseInt(employeeBooking.contractId.toString())
                        : null,
                      type: parseInt(employeeBooking.type.toString()),
                      personId: member.id,
                      colour: this.employeeBookingColourCodes.BY_WEBSITE
                    }
                  })
                )
              })
          }
        }
      })
    }

    this.actions$
      .pipe(
        ofType(employeeBookingActions.upsertMany),
        take(1),
        timeout(5000),
        catchError(() => of(null))
      )
      .subscribe((action) => {
        if (!action) {
          console.error('Failed to create employee booking before timeout')
          this.disableSaveButton$.next(false)
          return false
        }
        this.disableSaveButton$.next(false)
        this.notificationService.emit('alerts.success', 'success')
        this.cancel()
      })
  }

  private updateMultidayBooking(employeeBooking, daysOfBooking, member) {
    this.store
      .select(persistentUserRoleSelectors.selectSelectedUserRole)
      .pipe(take(1))
      .subscribe((pUr) => {
        const siteId =
          pUr && pUr.siteId ? pUr.siteId : environment.defaultSiteId
        daysOfBooking.forEach((day, index) => {
          // first day of booking
          if (index == 0) {
            this.store.dispatch(
              employeeBookingActions.updateOneById({
                id: this.employeeBooking.id,
                params: {
                  ...employeeBooking,
                  id: this.employeeBooking.id,
                  startDate: moment(employeeBooking.startDate),
                  endDate: moment(employeeBooking.startDate)
                    .endOf('day')
                    .subtract(1, 'minute'),
                  colour: this.employeeBookingColourCodes.BY_WEBSITE,
                  contractId: employeeBooking.contractId
                    ? parseInt(employeeBooking.contractId.toString())
                    : null,
                  personId: member?.id
                }
              })
            )
          }
          // last day of booking
          else if (index == daysOfBooking.length - 1) {
            this.store.dispatch(
              employeeBookingActions.createOne({
                entity: {
                  siteId: siteId,
                  ...employeeBooking,
                  ...this.employeeBooking,
                  id: null,
                  productId: employeeBooking.productId
                    ? parseInt(employeeBooking.productId.toString())
                    : null,
                  startDate: moment(day).startOf('day'),
                  endDate: moment(employeeBooking.endDate).subtract(
                    1,
                    'minute'
                  ),

                  contractId: employeeBooking.contractId
                    ? parseInt(employeeBooking.contractId.toString())
                    : null,
                  type: parseInt(employeeBooking.type.toString()),
                  personId: member.id,
                  colour: this.employeeBookingColourCodes.BY_WEBSITE
                }
              })
            )
          } // full day booking
          else {
            this.store.dispatch(
              employeeBookingActions.createOne({
                entity: {
                  siteId: siteId,
                  ...employeeBooking,
                  ...this.employeeBooking,
                  id: null,
                  productId: employeeBooking.productId
                    ? parseInt(employeeBooking.productId.toString())
                    : null,
                  startDate: moment(day).startOf('day'),
                  endDate: moment(day).endOf('day').subtract(1, 'minute'),
                  contractId: employeeBooking.contractId
                    ? parseInt(employeeBooking.contractId.toString())
                    : null,
                  type: parseInt(employeeBooking.type.toString()),
                  personId: member.id,
                  colour: this.employeeBookingColourCodes.BY_WEBSITE
                }
              })
            )
          }
        })
      })
  }

  private createMultidayBooking(employeeBooking, daysOfBooking, member) {
    this.store
      .select(persistentUserRoleSelectors.selectSelectedUserRole)
      .pipe(take(1))
      .subscribe((pUr) => {
        const siteId =
          pUr && pUr.siteId ? pUr.siteId : environment.defaultSiteId
        daysOfBooking.forEach((day, index) => {
          // first day of booking
          if (index == 0) {
            this.store.dispatch(
              employeeBookingActions.createOne({
                entity: {
                  siteId: siteId,
                  ...employeeBooking,
                  ...this.employeeBooking,
                  productId: employeeBooking.productId
                    ? parseInt(employeeBooking.productId.toString())
                    : null,
                  startDate: moment(employeeBooking.startDate),
                  endDate: moment(employeeBooking.startDate)
                    .clone()
                    .endOf('day')
                    .subtract(1, 'minute'),
                  contractId: employeeBooking.contractId
                    ? parseInt(employeeBooking.contractId.toString())
                    : null,
                  type: parseInt(employeeBooking.type.toString()),
                  personId: member.id,
                  colour: this.employeeBookingColourCodes.BY_WEBSITE
                }
              })
            )
          } // last day of booking
          else if (index == daysOfBooking.length - 1) {
            this.store.dispatch(
              employeeBookingActions.createOne({
                entity: {
                  siteId: siteId,
                  ...employeeBooking,
                  ...this.employeeBooking,
                  productId: employeeBooking.productId
                    ? parseInt(employeeBooking.productId.toString())
                    : null,
                  startDate: moment(day).startOf('day'),
                  endDate: moment(employeeBooking.endDate).subtract(
                    1,
                    'minute'
                  ),

                  contractId: employeeBooking.contractId
                    ? parseInt(employeeBooking.contractId.toString())
                    : null,
                  type: parseInt(employeeBooking.type.toString()),
                  personId: member.id,
                  colour: this.employeeBookingColourCodes.BY_WEBSITE
                }
              })
            )
          } // full day booking
          else {
            this.store.dispatch(
              employeeBookingActions.createOne({
                entity: {
                  siteId: siteId,
                  ...employeeBooking,
                  ...this.employeeBooking,
                  productId: employeeBooking.productId
                    ? parseInt(employeeBooking.productId.toString())
                    : null,
                  startDate: moment(day).startOf('day'),
                  endDate: moment(day).endOf('day').subtract(1, 'minute'),
                  contractId: employeeBooking.contractId
                    ? parseInt(employeeBooking.contractId.toString())
                    : null,
                  type: parseInt(employeeBooking.type.toString()),
                  personId: member.id,
                  colour: this.employeeBookingColourCodes.BY_WEBSITE
                }
              })
            )
          }
        })
      })
  }
}
